import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserDto } from '../../shared/service-proxies/service-proxies';

/**
 * Bu servisin adi, SubHeaderManager olarak degistirilecek.
 * Ust kisimdaki subHeader alanina deger gondermek icin kullanilir.
 */
@Injectable({
  providedIn: 'root'
})
export class TestService {

//#region Fields
  private title : BehaviorSubject<string> = new BehaviorSubject<string>('');
  private desc : BehaviorSubject<string> = new BehaviorSubject<string>('');

  private isOpenProductSearchBox : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isOpenUserCloneButton : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isPhotoDownloadButtonVisible : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private user : BehaviorSubject<UserDto> = new BehaviorSubject<UserDto>(null);


//#endregion

//#region Constructor
  constructor() { 
    this.title = new BehaviorSubject<string>('');
  }
  //#endregion

//#region Page Title and Desc
  setTitle(newValue) : void{
    this.title.next(newValue);
  }

  setDesc(newValue) : void{
    this.desc.next(newValue);
  }

  getTitle() : Observable<string>{
    return this.title.asObservable();
  }
 

  getDesc() : Observable<string>{
    return this.desc.asObservable();
  }

  setIsPhotoDownloadButton(isOpen: boolean): void{
    this.isPhotoDownloadButtonVisible.next(isOpen);
  }

  getIsPhotoDownloadButton(): BehaviorSubject<boolean>{
    return this.isPhotoDownloadButtonVisible ;
  }
//#endregion

//#region Product Search Box
  setIsOpenProductSearchBox(isOpen: boolean) : void{
    this.isOpenProductSearchBox.next(isOpen);
  }

  getIsOpenProductSearchBox() : Observable<boolean>{
    return this.isOpenProductSearchBox.asObservable();
  }
  //#endregion

  //#region Kullanici Klonla dugmesi...
  setIsOpenUserCloneButton(isOpen: boolean) : void{
    this.isOpenUserCloneButton.next(isOpen);
  }

  getIsOpenUserCloneButton() : Observable<boolean>{
    return this.isOpenUserCloneButton.asObservable();
  }
  //#endregion

  //#region Kullanici
  setUser(user: UserDto){
    this.user.next(user);
  }

  getUser(): Observable<UserDto>{
    return this.user.asObservable();
  }
  //#endregion

  reset() : void{
    this.setTitle('');
    this.setDesc('');
    this.setUser(null);
    this.setIsOpenUserCloneButton(false);
    this.setIsOpenProductSearchBox(false);
    this.setIsPhotoDownloadButton(false);

  }
}
